import styled from 'styled-components';

export const Root = styled.div`
  color: ${({ theme }) => theme.palette.text.subtle};
  font-style: italic;
`;
